export const aduanData = {
    channels: [
        {
            id: 'sp4n',
            name: 'SP4N LAPOR!',
            fullName: 'Sistem Pengelolaan Pengaduan Pelayanan Publik Nasional',
            icon: '🏛️',
            color: 'from-red-600 to-red-800',
            description: 'Sistem Pengaduan Pelayanan Publik Nasional yang dikelola oleh Kementerian PAN-RB',
            website: 'https://www.lapor.go.id',
            contact: '1708 (Call Center)',
            features: [
                'Pengaduan online 24/7',
                'Tracking status pengaduan',
                'Terintegrasi dengan instansi pemerintah',
                'Respon cepat dari admin',
                'Lapor melalui website atau aplikasi mobile'
            ],
            steps: [
                'Kunjungi website www.lapor.go.id atau download aplikasi SP4N LAPOR!',
                'Pilih kategori pengaduan',
                'Isi formulir pengaduan dengan lengkap',
                'Upload bukti pendukung (foto/dokumen)',
                'Submit dan catat nomor tiket',
                'Pantau status pengaduan secara online'
            ],
            image: 'https://placehold.co/800x400/DC2626/FFFFFF?text=SP4N+LAPOR!'
        },
        {
            id: 'monggo_lapor',
            name: 'Monggo Lapor',
            fullName: 'Aplikasi Pengaduan Masyarakat Kota Magelang',
            icon: '📱',
            color: 'from-blue-600 to-blue-800',
            description: 'Aplikasi pengaduan masyarakat Kota Magelang yang dikelola oleh Dinas Komunikasi dan Informatika',
            website: 'https://monggolapor.magelangkota.go.id',
            contact: 'WhatsApp: 0811-2600-170',
            features: [
                'Pengaduan khusus wilayah Kota Magelang',
                'Kategori pengaduan beragam',
                'Respon cepat dari OPD terkait',
                'Notifikasi status pengaduan',
                'Tersedia di Android dan iOS'
            ],
            steps: [
                'Download aplikasi Monggo Lapor di Play Store atau App Store',
                'Registrasi dengan NIK atau email',
                'Pilih jenis pengaduan',
                'Deskripsikan pengaduan dengan jelas',
                'Tambahkan foto lokasi',
                'Kirim dan pantau status pengaduan'
            ],
            image: 'https://placehold.co/800x400/2563EB/FFFFFF?text=Monggo+Lapor'
        },
        {
            id: 'whatsapp',
            name: 'WhatsApp Pengaduan',
            fullName: 'Layanan Pengaduan via WhatsApp BPKAD',
            icon: '💬',
            color: 'from-green-600 to-green-800',
            description: 'Layanan pengaduan melalui WhatsApp resmi BPKAD Kota Magelang',
            website: 'https://wa.me/628112600170',
            contact: '0811-2600-170',
            features: [
                'Langsung terhubung dengan petugas',
                'Bisa mengirim foto dan video',
                'Respon real-time',
                'Tidak perlu install aplikasi tambahan',
                'Tersedia di jam kerja'
            ],
            steps: [
                'Simpan nomor WhatsApp BPKAD: 0811-2600-170',
                'Kirim pesan dengan format: Nama, Alamat, Keluhan',
                'Sertakan foto atau video pendukung',
                'Tunggu konfirmasi dari petugas',
                'Ikuti instruksi selanjutnya dari petugas'
            ],
            image: 'https://placehold.co/800x400/16A34A/FFFFFF?text=WhatsApp+Pengaduan'
        },
        {
            id: 'email',
            name: 'Email Pengaduan',
            fullName: 'Layanan Pengaduan via Email Resmi',
            icon: '📧',
            color: 'from-purple-600 to-purple-800',
            description: 'Saluran pengaduan resmi melalui email BPKAD Kota Magelang',
            website: 'mailto:aduan@magelangkota.go.id',
            contact: 'aduan@magelangkota.go.id',
            features: [
                'Pengaduan resmi tercatat',
                'Bisa melampirkan dokumen',
                'Jejak komunikasi tersimpan',
                'Balasan resmi dari instansi',
                'Akses kapan saja'
            ],
            steps: [
                'Buat email baru ke: aduan@magelangkota.go.id',
                'Subject: [ADUAN] - Jenis Pengaduan',
                'Jelaskan kronologi pengaduan dengan detail',
                'Lampirkan foto, video, atau dokumen pendukung',
                'Cantumkan nama dan nomor yang bisa dihubungi',
                'Kirim dan tunggu balasan dari petugas'
            ],
            image: 'https://placehold.co/800x400/7C3AED/FFFFFF?text=Email+Pengaduan'
        },
        {
            id: 'telepon',
            name: 'Telepon Pengaduan',
            fullName: 'Layanan Call Center BPKAD',
            icon: '📞',
            color: 'from-orange-600 to-orange-800',
            description: 'Layanan pengaduan melalui telepon langsung ke kantor BPKAD',
            website: 'tel:0293123456',
            contact: '(0293) 123456',
            features: [
                'Komunikasi langsung dengan petugas',
                'Penanganan cepat',
                'Konsultasi masalah',
                'Tersedia di jam kerja',
                'Bebas pulsa'
            ],
            steps: [
                'Hubungi nomor (0293) 123456',
                'Pilih menu pengaduan',
                'Sampaikan keluhan kepada petugas',
                'Catat nomor tiket pengaduan',
                'Simpan nomor tiket untuk follow up'
            ],
            image: 'https://placehold.co/800x400/EA580C/FFFFFF?text=Telepon+Pengaduan'
        },
        {
            id: 'kotak_aduan',
            name: 'Kotak Pengaduan',
            fullName: 'Kotak Pengaduan Fisik',
            icon: '📮',
            color: 'from-teal-600 to-teal-800',
            description: 'Kotak pengaduan fisik yang tersedia di kantor BPKAD dan tempat umum',
            website: null,
            contact: 'Tersedia di kantor BPKAD dan kantor kecamatan',
            features: [
                'Tidak memerlukan teknologi',
                'Bisa anonim',
                'Tersedia di lokasi strategis',
                'Formulir tersedia',
                'Pengecekan rutin oleh petugas'
            ],
            steps: [
                'Kunjungi kantor BPKAD atau kantor kecamatan terdekat',
                'Ambil formulir pengaduan di kotak yang tersedia',
                'Isi formulir dengan lengkap (bisa anonim)',
                'Masukkan ke dalam kotak pengaduan',
                'Petugas akan memproses secara berkala'
            ],
            image: 'https://placehold.co/800x400/0D9488/FFFFFF?text=Kotak+Pengaduan'
        }
    ],
    info: {
        title: 'Mekanisme Penanganan Pengaduan',
        steps: [
            {
                step: 1,
                title: 'Penerimaan',
                description: 'Pengaduan diterima melalui berbagai kanal (online, telepon, langsung)',
                duration: '1 hari kerja'
            },
            {
                step: 2,
                title: 'Verifikasi',
                description: 'Petugas memverifikasi kebenaran dan kelengkapan data pengaduan',
                duration: '1-2 hari kerja'
            },
            {
                step: 3,
                title: 'Disposisi',
                description: 'Pengaduan diteruskan ke bidang/unit terkait untuk ditindaklanjuti',
                duration: '1 hari kerja'
            },
            {
                step: 4,
                title: 'Tindak Lanjut',
                description: 'Bidang/unit terkait menindaklanjuti dan menyelesaikan pengaduan',
                duration: '3-7 hari kerja'
            },
            {
                step: 5,
                title: 'Pelaporan',
                description: 'Hasil tindak lanjut dilaporkan dan diinformasikan kepada pelapor',
                duration: '1-2 hari kerja'
            }
        ],
        guarantee: [
            'Identitas pelapor dijamin kerahasiaannya',
            'Setiap pengaduan akan ditindaklanjuti',
            'Respon maksimal 5 hari kerja',
            'Penyelesaian maksimal 14 hari kerja',
            'Tidak dipungut biaya (GRATIS)'
        ]
    }
};